import { render, staticRenderFns } from "./OrderAmout.vue?vue&type=template&id=6e87b72f&scoped=true"
import script from "./OrderAmout.vue?vue&type=script&lang=js"
export * from "./OrderAmout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e87b72f",
  null
  
)

export default component.exports